<template>
  <div
    class="col-12"
    @click="gotoContent">
    <div class="row">
      <span
        v-if="item.note"
        class="service_note">{{ item.note }}</span>
      <div class="body-service">
        <div class="body-service-left">
          <img
            :src="base_url + item.image"
            alt=""
            width="100%"
            height="100%">
        </div>
        <div class="body-service-right"><p>{{ item.name }}</p></div>
      </div>
    </div>
  </div>
</template>

<script>
  import ApiConfig from '../../communicate/ApiConfig'

  export default {
    name: "ServiceItemPaid",
    // eslint-disable-next-line vue/require-prop-types
    props: ["item"],
    data () {
      return {
        base_url: ApiConfig.base_url
      }
    },
    methods: {
      gotoContent() {
        console.log('gotoContent')
        this.$emit('dvContent', this.item);
      }
    }
  }
</script>

<style scoped>
  .body-service {
    width: 100%;
    height: auto;
    display: -webkit-flex; /* Safari */
    display: flex;
    padding: 10px 0 10px 0;
  }

  .body-service .body-service-left {
    -webkit-flex-grow: 0; /* Safari 6.1+ */
    -webkit-flex-shrink: 0; /* Safari 6.1+ */
    -webkit-flex-basis: 30%; /* Safari 6.1+ */
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 30%;
  }

  .body-service .body-service-right {
    -webkit-flex-grow: 0; /* Safari 6.1+ */
    -webkit-flex-shrink: 0; /* Safari 6.1+ */
    -webkit-flex-basis: 30%; /* Safari 6.1+ */
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 70%;
    font-size: .9rem;
  }

  .body-service .body-service-right p {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding-left: 10px;
    color: #000;

  }
</style>



// WEBPACK FOOTER //
// src/components/service/ServiceItemPaid.vue